module.exports = __webpack_public_path__ + "static/media/navMenuBG.aa2fb734.jpg";